<ion-row class="green-wrapper" [class.green-eggs]="easterEgg">
  <ion-col
    size="12"
    size-lg="6"
    push-lg="6"
    size-xl="8"
    push-xl="4"
    class="no-padding-col ion-text-center"
    id="right-container">
    <img
      (click)="navigateToDashboard()"
      [src]="
        (theme$ | async) === 'dark-theme'
          ? 'assets/images/SC_D_Logo_Horizontal-LM.svg'
          : '/assets/images/SC_D_Logo_Horizontal-DM.svg'
      "
      alt="SquadCast Logo"
      id="logo" />

    <sc-preview-test [joining]="joining" (shutdown)="previewShutdown.next()" (testResults)="testResults($event)"></sc-preview-test>

    <sc-test-equipment *ngIf="session$?.value.confType !== 'daily'"></sc-test-equipment>
  </ion-col>

  <ion-col size="12" size-lg="6" pull-lg="6" size-xl="4" pull-xl="8" class="no-padding-col" id="left-container">
    <div class="padding">
      <div id="green-room-panel" class="ion-text-center">
        <h3 class="bold" (dblclick)="toggleEasterEgg()">Green Room</h3>

        <p class="ion-text-center ion-hide-sm-down description">
          A place where you can prepare, in private, before your Recording Session.
        </p>

        <ion-list lines="none">
          <ion-item class="name-pronoun-container input-small" [class.hasPhoto]="(user$ | async)?.photoURL">
            <sc-avatar [photoURL]="(user$ | async)?.photoURL"></sc-avatar>

            <ion-input
              scAutoFocus
              [(ngModel)]="name"
              (keyup.enter)="joinSession()"
              (ionBlur)="setName()"
              placeholder="Name"
              class="name-field">
            </ion-input>

            <ion-input
              [(ngModel)]="pronouns"
              (keyup.enter)="joinSession()"
              (ionBlur)="setName()"
              placeholder="Pronouns"
              class="pronoun-field">
            </ion-input>
          </ion-item>

          <div aria-label="Echo Cancellation" class="echo-cancellation">
            <div class="echo-cancellation-info">
              <div class="echo-cancellation-label" (click)="openEchoCancellationInfoMenu($event)">
                <ion-icon *ngIf="!echoCancellation" src="assets/icons/24px/headphones.svg" class="ion-hide-sm-down">
                </ion-icon>
                <ion-icon *ngIf="echoCancellation" src="assets/icons/24px/headphones-off.svg" class="ion-hide-sm-down">
                </ion-icon>

                <ion-label>
                  <h6>Echo Cancellation</h6>
                  <p>For when you aren't wearing headphones</p>
                </ion-label>
              </div>

              <ion-toggle
                *ngIf="echoCancellation !== undefined"
                class="echo-cancellation-toggle"
                [checked]="echoCancellation"
                (ionChange)="toggleEchoCancellation($event)"
                mode="ios">
              </ion-toggle>
            </div>
            <div class="echo-cancellation-status micro-bold">
              <span>{{ echoCancellation ? 'ON' : 'OFF' }}</span>
            </div>
          </div>

          <sc-equipment-list ui="green-room" slot="content"> </sc-equipment-list>
        </ion-list>
      </div>

      <div id="footer">
        <sc-show-session-label></sc-show-session-label>
        <!-- <div *ngIf="(session$ | async).descriptInstant && (shows$ | async).length > 1">
          <p class="ion-text-center ion-hide-sm-down description" >
            Change where your Descript Instant Session is recorded.
          </p>
          <ion-button (click)="openMoveSessionModal()">Change the show</ion-button>
        </div> -->
      </div>
    </div>

    <div class="joinButtonContainer">
      <div lines="none" class="in-session" *ngIf="activeParticipants?.length">
        <h6>In Session</h6>
        <sc-team-list [team]="activeParticipants" [checkParticipants]="true"></sc-team-list>
      </div>

      <ion-item [hidden]="session$?.value.confType === 'daily' || dolbyInitialized" lines="none">
        <ion-progress-bar type="indeterminate" color="secondary" id="loading"> </ion-progress-bar>
      </ion-item>

      <p *ngIf="muteOnJoin" class="ion-text-center"><small> You will join muted </small></p>

      <ion-button
        (click)="joinSession()"
        aria-label="Join Session"
        [hidden]="!dolbyInitialized || joinTestSuccess"
        disabled="true"
        id="join"
        [class]="deviceInfo.browser === 'Safari' ? 'pulse-once primary' : 'pulse primary'"
        alt="Connecting to Session"
        shape="round"
        size="large">
        Checking Connection
      </ion-button>

      <ion-button
        (click)="joinSession()"
        aria-label="Join Session"
        [hidden]="(session$?.value.confType !== 'daily' && !joinTestSuccess) || !dailyInitialized"
        disabled="{{
          joining ||
            notSupported ||
            ((session$ | async)?.communityEvent === true &&
              !((user$ | async)?.email?.includes('@squadcast.fm') || (user$ | async)?.guest === true))
        }}"
        id="join"
        [class]="deviceInfo.browser === 'Safari' ? 'pulse-once primary' : 'pulse primary'"
        alt="Start Session"
        shape="round"
        size="large">
        {{notSupported ? 'Browser is Not Supported' : joining ? 'Joining...' : 'Join Session'}}
      </ion-button>

      <ion-button *ngIf="!dailyInitialized" disabled="true" id="join" shape="round" size="large">
        Checking Connection...
      </ion-button>

      <ion-button
        aria-label="Open Support Center"
        id="need-help"
        class="text"
        expand="block"
        size="small"
        (click)="openSupportCenter()">
        Need help?
      </ion-button>

      <p class="ion-text-center">
        <small>
          By clicking Join Session you agree to our
          <a href="https://squadcast.fm/terms-conditions/" alt="Terms and Conditions" target="_blank" class="underline"
            >Terms</a
          >
          and
          <a href="https://squadcast.fm/privacy-policy/" alt="Privacy Policy" target="_blank" class="underline"
            >Policies</a
          >.
        </small>
      </p>
    </div>
  </ion-col>
</ion-row>
